import React from "react";
import { cx } from "../utils";

/** Vertical list wrapper for CcVersionCard entries. */
const CcVersionTimeline = ({ className, children, ...props }) => (
  <div className={cx("cc-version-timeline", className)} {...props}>
    {children}
  </div>
);

export default CcVersionTimeline;
